module.exports = __webpack_public_path__ + "img/insights.ea736a5d.png";